
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class Search extends Vue {
  @Prop() private msg!: string;

  get stampCode(): string {
    return this.$store.getters.stampCode
  }

  set stampCode(code: string) {
    this.$store.commit('setStampCode', code)
  }

  search() {
    this.$store.dispatch('search')
  }
}
